import React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { theme } from 'theme';

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    color: palette.primary.contrastText,
    display: 'flex',
    alignItems: 'flex-end',
    position: 'relative',
  },
  background: {
    width: '100%',
    height: 330,
    objectFit: 'cover',
  },
  content: {
    position: 'absolute',
    padding: spacing(2),
    background: alpha(palette.primary.main, 0.56),
    whiteSpace: 'pre-line',
  },
  title: {
    marginBottom: theme.spacing(1.5),
  },
}));

const InfoCard = ({ onClick, title, text, imgUrl, contentHeight }) => {
  const classes = useStyles({ imgUrl });

  return (
    <Card onClick={onClick}>
      <CardActionArea className={classes.root}>
        <img src={imgUrl} alt="background" className={classes.background} />
        <Box className={classes.content} width={1} height={contentHeight || 165}>
          <Typography gutterBottom variant="h5" component="h2" className={classes.title}>
            {title}
          </Typography>
          <Typography variant="body1" component="p">
            {text}
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  );
};

InfoCard.defaultProps = {
  title: null,
  text: null,
  imgUrl: null,
  contentHeight: undefined,
};

InfoCard.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  imgUrl: PropTypes.string,
  contentHeight: PropTypes.number,
};

export default InfoCard;
